"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.linkPreviewAllowedRefererList = exports.LINK_PREVIEW_DEFAULT_URL = void 0;
exports.LINK_PREVIEW_DEFAULT_URL = "/Assets/Images/share-default.jpg";
exports.linkPreviewAllowedRefererList = ["facebook.com", "linkedin.com", "t.co", "paper.dropbox.com"];
